import { Button, Popconfirm, Space, Table, message } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BlogPage = () => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const columns = [
    {
      title: "Blog Görseli",
      dataIndex: "img",
      key: "img",
      render: (imgSrc) => <img src={imgSrc} alt="Blog Görseli" width={100} />,
    },
    {
      title: "Blog Başlığı",
      dataIndex: "name",
      key: "name",
      render: (text) => {
        // HTML etiketlerini kaldıran bir fonksiyon
        const removeHtmlTags = (str) => {
          return str.replace(/<[^>]*>/g, ""); // HTML etiketlerini siler
        };
  
        return <b>{removeHtmlTags(text)}</b>; // Başlık metnini etiketlerden arındırır
      },
    },
    {
      title: "Yayın Tarihi",
      dataIndex: "publishedDate",
      key: "publishedDate",
      render: (date) => new Date(date).toLocaleDateString(),
    },
    {
      title: "Eylemler",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            onClick={() => navigate(`/admin/blogs/update/${record.id}`)}
          >
            Düzenle
          </Button>
          <Popconfirm
            title="Blog Yazısını Sil"
            description="Blog yazısını silmek istediğinizden emin misiniz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => deleteProduct(record.id)}
          >
            <Button type="primary" danger>
              Sil
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const deleteProduct = async (blogId) => {
    try {
      const response = await fetch(`${apiUrl}/api/blogs/${blogId}`, {
        method: "DELETE",
      });

      if (response.ok) {
        message.success("Blog başarıyla silindi.");
        setDataSource((prevBlogs) => prevBlogs.filter((blog) => blog.id !== blogId));
      } else {
        const errorData = await response.json();
        message.error(`Silme işlemi başarısız: ${errorData.error}`);
      }
    } catch (error) {
      console.log("Silme hatası:", error);
      message.error("Silme işlemi sırasında hata oluştu.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const blogsResponse = await fetch(`${apiUrl}/api/blogs`);
        
        if (!blogsResponse.ok) {
          message.error("Blog verileri alınamadı.");
          return; 
        }

        const blogsData = await blogsResponse.json();

        setDataSource(blogsData);
      } catch (error) {
        console.log("Veri hatası:", error);
        message.error("Veri getirme işlemi sırasında hata oluştu.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [apiUrl]);

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      rowKey={(record) => record.id}
      loading={loading}
    />
  );
};

export default BlogPage;
